import produce from 'immer'
import { assign, get } from 'lodash'

import {
  FETCH_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES,
  RESET_INGREDIENT_TREE,
  SAVE_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES,
} from '../action-types'
import { INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES_INITIAL_STATE } from '../initial-states'

const ingredientCommonNegativeSynonymPhrasesReducer = (
  state = INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES_INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case FETCH_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: [],
          latestEvent: undefined,
        }),
      )

    case FETCH_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES.COMPLETE:
      return produce(state, nextState => {
        const { results, latestEvent } =
          action.payload.data.ingredientCommonNegativeSynonymPhrases

        return assign(nextState, {
          isLoading: false,
          error: undefined,
          data: results,
          latestEvent,
        })
      })

    case FETCH_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: { message: action.error.message },
          data: [],
          latestEvent: undefined,
        }),
      )

    case FETCH_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES.CLEANUP:
      return { ...INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES_INITIAL_STATE }

    case SAVE_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          latestEvent: undefined,
        }),
      )

    case SAVE_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES.COMPLETE:
      return produce(state, nextState => {
        const { results, latestEvent } =
          action.payload.data.saveIngredientCommonNegativeSynonymPhrases

        return assign(nextState, {
          isLoading: false,
          error: undefined,
          data: results,
          latestEvent,
        })
      })

    case SAVE_INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASES.FAIL:
      return produce(state, nextState => {
        const { graphQLErrors, message } = action.error

        const errorDetails = get(
          graphQLErrors,
          '[0].extensions.exception.duplicated',
        )

        return assign(nextState, {
          isLoading: false,
          error: {
            errorDetails,
            message,
          },
        })
      })

    case RESET_INGREDIENT_TREE:
      return produce(state, nextState =>
        assign(nextState, {
          ...nextState,
          data: nextState.initialData,
          isDirty: false,
          dataForRenaming: undefined,
        }),
      )

    default:
      return state
  }
}

export default ingredientCommonNegativeSynonymPhrasesReducer
